import React, { Component } from 'react';

class Message extends Component {

  render() {

    return (
      <div className='finalmessage'>
        <p>Message...</p>
        <p>{this.props.selectedId}</p>
        {this.props.onSelect &&
          <button onClick={() => this.props.onSelect(200, "Test")}>test</button>
        }
      </div>
    );
  }
}

export default Message;

